import {config} from "@shared/_services/config";
import {HTTP} from "../_helpers/http";

export default class FileApi {
    static fetchImages() {
        return HTTP.get(config.fileApi.image)
            .then(response => response.data);
    }

    static upload(file) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return HTTP.post(config.fileApi.image, formData)
            .then(response => response.data);
    }
}